export default {
    offerEstimated: {
        en: {
            subject: 'Estimate #',
            greeting: 'Hello,<br>',
            // text: 'We’ve prepared a service estimate based on your request.',
            text: 'A price estimate has been prepared for you and is available as a PDF in the attachment.',
            linkText: 'You can view the details and book a convenient time by clicking the link',
            pinText: 'PIN'
        },
        et: {
            subject: 'Hinnapakkumine #',
            greeting: 'Tere,<br>',
            // text: 'Oleme teile koostanud hinnapakkumise.',
            // text: 'Oleme koostanud hinnapakkumise teie päringu alusel.',
            // text: 'Oleme koostanud teile hinnapakkumise. Fail on lisatud sellele kirjale.',
            text: 'Teile on koostatud hinnapakkumine, mis on manuses PDF-formaadis kättesaadav.',
            // linkText: 'Hinnapakkumisega saate tutvuda ja broneerida sobiv aeg vajudes linki: ',
            linkText: 'Saate seda vaadata ja broneerida sobiva aja lingi kaudu',
            pinText: 'PIN'
        },
        ru: {
            subject: 'Ценовое предложение #',
            greeting: 'Здравствуйте,<br>',
            // text: 'Для Вас подготовлено ценовое предложение.',
            // text: 'Мы подготовили ценовое предложение на обслуживание по вашему запросу.',
            // text: 'Для вас подготовлено ценовое предложение. Файл приложен к этому письму.',
            text: 'Для вас подготовлено ценовое предложение, которое доступно в приложении в формате PDF.',
            linkText: 'Вы можете ознакомиться с деталями и записаться на удобное время по ссылке',
            pinText: 'ПИН-код'
        },
        lv: {
            "subject": "Cenas piedāvājums #",
            "greeting": "Labdien,<br>",
            "text": "Jums sagatavots cenas piedāvājums, kas pievienots šim e-pastam PDF formātā.",
            "linkText": "Apskatiet informāciju un izvēlieties ērtu pieraksta laiku, izmantojot saiti",
            "pinText": "PIN kods"
        },
        lt: {
            "subject": "Kainos pasiūlymas #",
            "greeting": "Sveiki,<br>",
            "text": "Jums parengtas kainos pasiūlymas, pridėtas prie šio laiško PDF formatu.",
            "linkText": "Peržiūrėkite informaciją ir pasirinkite patogų vizito laiką paspaudę nuorodą",
            "pinText": "PIN kodas"
        },
        fi: {
            "subject": "Tarjous #",
            "greeting": "Hei,<br>",
            "text": "Olemme laatineet sinulle tarjouksen, joka on viestin liitteenä PDF-muodossa.",
            "linkText": "Voit katsoa tiedot ja varata sopivan ajan linkistä",
            "pinText": "PIN-koodi"
        },
    },
    salesInvoice: {
        en: {
            subject: 'Invoice #',
            text: 'Hello,<br>Your invoice has been issued. The document is attached as a PDF file.'
        },
        et: {
            subject: 'Arve #',
            text: 'Tere,<br>Teile on koostatud arve. Dokument on manuses PDF-failina.'
        },
        ru: {
            subject: 'Счет #',
            text: 'Здравствуйте,<br>Для вас подготовлен счёт. Документ прикреплён к письму в формате PDF.'
        },
        lv: {
            "subject": "Rēķins #",
            "text": "Labdien,<br>Jums sagatavots rēķins. Dokuments pievienots e-pastam PDF formātā."
        },
        lt: {
            "subject": "Sąskaita #",
            "text": "Sveiki,<br>Jums parengta sąskaita. Dokumentas pridėtas prie laiško PDF formatu."
        },
        fi: {
            "subject": "Lasku #",
            "text": "Hei,<br>Olemme laatineet sinulle laskun. Asiakirja on viestin liitteenä PDF-muodossa."
        },
    },
    prepaymentInvoice: {
        en: {
            subject: 'Prepayment Invoice #',
            text: 'Hello,<br>Your prepayment invoice has been issued. The document is attached as a PDF file.'
        },
        et: {
            subject: 'Ettemaksuarve #',
            text: 'Tere,<br>Teile on koostatud ettemaksuarve. Dokument on manuses PDF-failina.'
        },
        ru: {
            subject: 'Счет на предоплату #',
            text: 'Здравствуйте,<br>Для вас подготовлен счёт на предоплату. Документ прикреплён к письму в формате PDF.'
        },
        lv: {
            "subject": "Priekšapmaksas rēķins #",
            "text": "Labdien,<br>Jums sagatavots priekšapmaksas rēķins. Dokuments pievienots e-pastam PDF formātā."
        },
        lt: {
            "subject": "Išankstinė sąskaita #",
            "text": "Sveiki,<br>Jums parengta išankstinė sąskaita. Dokumentas pridėtas prie laiško PDF formatu."
        },
        fi: {
            "subject": "Ennakkolasku #",
            "text": "Hei,<br>Olemme laatineet sinulle ennakkolaskun. Asiakirja on viestin liitteenä PDF-muodossa."
        },
    },
    orderFiles: {
        en: {
            subject: 'Files for order #',
            text: 'Hello,<br>Please find attached the files related to your order.'
        },
        et: {
            subject: 'Tellimuse failid #',
            text: 'Tere,<br>Manusest leiate teie tellimusega seotud failid.'
        },
        ru: {
            subject: 'Файлы по заказу #',
            text: 'Здравствуйте,<br>Во вложении вы найдёте файлы, связанные с вашим заказом.'
        },
        lv: {
            "subject": "Pasūtījuma faili #",
            "text": "Labdien,<br>Pielikumā atradīsiet ar jūsu pasūtījumu saistītos failus."
        },
        lt: {
            "subject": "Užsakymo failai #",
            "text": "Sveiki,<br>Priede rasite su jūsų užsakymu susijusius failus."
        },
        fi: {
            "subject": "Tilauksen tiedostot #",
            "text": "Hei,<br>Liitteenä ovat tilaukseesi liittyvät tiedostot."
        },
    }
}